 <template>
   <v-app>
     <v-navigation-drawer dark v-if="isAuthed" v-model="drawer" app class="sidebar hf-scrollbar-dark" fixed clipped>
       <v-list class="px-1 tile-spacing">
         <div id="step7">
           <v-list-tile :to="{ name: 'home' }" ripple exact active-class="activeLink">
             <v-list-tile-action>
               <v-icon>home</v-icon>
             </v-list-tile-action>
             <v-list-tile-content>{{ $t("App.Home") }}</v-list-tile-content>
           </v-list-tile>

           <v-list-tile v-if="hasSampleData" ripple :to="{ name: 'allimports' }" active-class="activeLink">
             <v-list-tile-action>
               <v-icon>event_note</v-icon>
             </v-list-tile-action>
             <v-list-tile-title>{{ $t("App.Imports") }}</v-list-tile-title>
           </v-list-tile>
           <v-list-tile v-if="hasSampleData" ripple :to="{ name: 'guidelines' }" active-class="activeLink">
             <v-list-tile-action>
               <v-icon>rule</v-icon>
             </v-list-tile-action>
             <v-list-tile-title>{{ $t("App.Guidelines") }}</v-list-tile-title>
           </v-list-tile>

           <Reports v-if="hasSampleData" />

           <v-list-tile v-if="hasSampleData" ripple :to="{ name: 'datasets' }" active-class="activeLink">
             <v-list-tile-action>
               <v-icon>perm_media</v-icon>
             </v-list-tile-action>
             <v-list-tile-title>{{ $t("App.Files") }}</v-list-tile-title>
           </v-list-tile>
         </div>

         <TenantManagement />
         <v-divider />
         <StationSideMenu id="step6" />
       </v-list>
     </v-navigation-drawer>

     <v-toolbar :color="$store.state.currentColor" fixed clipped-left dark app id="main-toolbar">
       <div style="padding: 8px 0" id="step2">
         <v-toolbar-side-icon class="box-shadow" color="navbar" v-show="isAuthed" @click.stop="drawer = !drawer" />
       </div>
       <v-toolbar-title v-if="!$vuetify.breakpoint.xsOnly || !showSearching" style="width: 200px;" class="ml-0 pl-3">
         <router-link to="/" class="title">
           <!-- V:\Data\Admin\_HCL_graphics\_Hatfield_Digital\01_Hatfield_Logo\Hatfield Initiatives\Logo files for Web -->
           <img src="/static/images/logo.svg" width="160px" style="margin-bottom: -7px" />
         </router-link>
       </v-toolbar-title>

       <v-spacer />

       <JumpToStationSearch v-if="isAuthed" @showSearching="showSearching = $event" />

       <v-spacer v-if="!$vuetify.breakpoint.xsOnly" />

       <div style="padding: 8px 0" id="step4">
         <v-btn
            color="#529844"
            class="ma-2 white--text"
            fab
            small
            @click="openHelp"
          >
            <v-icon dark>
              mdi-book-open
            </v-icon>
          </v-btn>
       </div>
       <div v-if="isAuthed && isSystemAdmin" style="padding: 8px 0" id="step4">
         <AdministrationEntrance v-if="isAuthed && isSystemAdmin"></AdministrationEntrance>
       </div>

       <div v-if="isAuthed" style="padding: 8px 0" id="step5">
         <v-menu offset-y left>
           <template v-slot:activator="{ on }">
             <v-btn round class="box-shadow" color="navbar" v-on="on">
               <v-icon class="mr-1">person</v-icon>
               <div class="text-none">{{ username }} [ {{currentUserGroup.name}} ]</div>
             </v-btn>
           </template>

           <v-list dense dark>
            <v-list-tile @click="goToSwitchTenant()" v-if="hasOffice365Authorized">
               <v-list-tile-avatar>
                 <v-icon>mdi-swap-horizontal</v-icon>
               </v-list-tile-avatar>
               <v-list-tile-content>
                 <v-list-tile-title>{{ $t("App.SwitchTenant") }}</v-list-tile-title>
               </v-list-tile-content>
             </v-list-tile>
             <v-divider v-if="hasOffice365Authorized"></v-divider>
             <v-list-tile @click="goToMessageCenter()">
               <v-list-tile-avatar>
                 <v-icon>mdi-message</v-icon>
               </v-list-tile-avatar>
               <v-list-tile-content>
                 <v-list-tile-title>Message Center</v-list-tile-title>
               </v-list-tile-content>
             </v-list-tile>
             <v-divider></v-divider>
             <v-list-tile @click="goToUserProfile()">
               <v-list-tile-avatar>
                 <v-icon>person</v-icon>
               </v-list-tile-avatar>
               <v-list-tile-content>
                 <v-list-tile-title>{{ $t("App.UserProfile") }}</v-list-tile-title>
               </v-list-tile-content>
             </v-list-tile>
             
             <v-list-tile @click="logOut({ redirect: true })">
               <v-list-tile-avatar>
                 <v-icon>logout</v-icon>
               </v-list-tile-avatar>
               <v-list-tile-content>
                 <v-list-tile-title>{{ $t("App.Logout") }}</v-list-tile-title>
               </v-list-tile-content>
             </v-list-tile>
           </v-list>
         </v-menu>
       </div>
     </v-toolbar>

     <v-content :style="{ 'height': fullScreen ? '100vh' : '', 'overflow': fullScreen ? 'hidden' : '' }">
       <v-container fluid style="height: 100%">
         <router-view v-show="isApplicationLoaded || !isAuthed" :key="$route.fullPath"></router-view>
       </v-container>

       <v-footer v-if="!hideFooter" height="100">
         <v-layout justify-center align-center>
           <v-flex xs12 text-xs-center :style="{'margin-top': '12px'}">
             <a class="text-xs-center" href="https://www.hatfieldgroup.com/">
               <!-- V:\Data\Admin\_HCL_graphics\_Hatfield_Digital\01_Hatfield_Logo\Hatfield_HLogo\SVG -->
               <img src="/static/images/Hatfield-HLogo.svg" width="243px" class="logo" />
             </a>
           </v-flex>
           <v-flex xs12 text-xs-left>             
           {{ new Date().getFullYear() }} — <strong>Envirodata</strong>
           </v-flex>
         </v-layout>
       </v-footer>
     </v-content>

     <LoadingScreen />

     <v-btn v-if="btnFlag" fab dark small color="primary" class="top" @click="backTop()">{{ $t("App.Top") }}</v-btn>

     <v-snackbar v-if="snackbar.text" class="mt-3 main-snackbar" top :color="snackbar.color" v-model="snackbarSettings.show" :timeout="snackbar.timeout !== null ? snackbar.timeout : snackbarSettings.timeout" auto-height>
       <v-icon v-if="snackbar.icon" color="white" class="mr-2">{{
         snackbar.icon
       }}</v-icon>
       {{ snackbar.text }}
       <v-btn flat @click="snackbarSettings.show = false">{{ $t("Button.Close") }}</v-btn>
     </v-snackbar>

     <StackMessages v-if="isAuthed"></StackMessages>
   </v-app>
 </template>

 <script>
   import {
     createNamespacedHelpers,
   } from 'vuex'

   import LoadingScreen from './components/LoadingScreen'
   import AdministrationEntrance from './components/AdministrationEntrance'
   import StationSideMenu from './components/Navigation/SideMenu/StationSideMenu'
   import TenantManagement from './components/Navigation/SideMenu/TenantManagement'
   import JumpToStationSearch from './components/JumpToStationSearch'

   //import IntroApp from '@/components/mixins/IntroApp'
   import Reports from '@/components/ReportsGroup/Reports'

   import StackMessages from '@/components/generic/alerts/StackMessages'

   import * as authService from './helpers/Office365/azureAuthService'

   const app = createNamespacedHelpers('app')
   const stations = createNamespacedHelpers('stations')
   const authenticate = createNamespacedHelpers('authenticate')

   export default {
     name: 'app',
     components: {
       LoadingScreen,
       AdministrationEntrance,
       TenantManagement,
       Reports,
       StationSideMenu,
       JumpToStationSearch,
       StackMessages,
     },
     //mixins: [IntroApp],
     data() {
       return {
         snackbarSettings: {
           show: false,
           timeout: 5000,
         },
         btnFlag: false,
         showSearching: false,
         drawer: null,
         stations: [],
         searching: false,
         title: 'EnviroData',
         hasOffice365Authorized: false,
       }
     },
     computed: {
       ...app.mapGetters(['isApplicationLoaded', 'languages']),
       ...stations.mapGetters(['recentStationIdsNavigated', 'ContinuousGrouper']),
       ...authenticate.mapGetters([
         'isAuthed',
         'username',
         'hasContinuousData',
         'hasSampleData',
         'hasContinuousData',
         'isSystemAdmin',
         'isTenantAdmin',
         'currentUserGroup',
       ]),
       snackbar() {
         return this.$store.getters['app/snackbar']
       },
       hideFooter() {
         return this.fullScreen || this.$route.meta && this.$route.meta.hideFooter
       },
       fullScreen() {
         return this.$route.meta && this.$route.meta.fullScreen
       },
     },
     watch: {
       drawer() {
         this.navDrawerChanged()
       },
       snackbar(val) {
         // Ignore empty text
         if (val.text) this.snackbarSettings.show = true
       },
       username() {
         var account = authService.getActiveAzureAccount()
         this.hasOffice365Authorized = (account != null)
       },
     },
     methods: {
       ...app.mapActions([
         'navDrawerChanged',
       ]),
       ...authenticate.mapActions(['logOut']),
       changeLanguage(local) {
         this.$i18n.locale = local
         window.localStorage.language = local
       },
       openHelp() {
         window.open('https://docs.envirodata.io/', '_blank')
       },       
       goToSwitchTenant() {
         this.$router.push({
           name: 'Office365AuthResponse',              
         })
       },
       goToMessageCenter() {
         this.$router.push({
           name: 'MessageCenter',
         })
       },
       goToUserProfile() {
         this.$router.push({
           name: 'UserProfile',
         })
       },
       backTop() {
         const self = this
         let timer = setInterval(() => {
           let ispeed = Math.floor(-self.scrollTop / 5)
           document.documentElement.scrollTop = document.body.scrollTop =
             self.scrollTop + ispeed
           if (self.scrollTop === 0) {
             clearInterval(timer)
           }
         }, 10)
       },
       scrollToTop() {
         let scrollTop =
           window.pageYOffset ||
           document.documentElement.scrollTop ||
           document.body.scrollTop
         this.scrollTop = scrollTop
         if (this.scrollTop > 100) {
           this.btnFlag = true
         } else {
           this.btnFlag = false
         }
       },
       searchAlias() {
         if (this.search) {
           let url = 'api/StationManagement/Search'
           let options = {
             SearchData: this.search,
             TenantId: this.currentUserGroup.id,
           }
           this.axios.post(url, options)
             .then(res => {
               let aliasList = JSON.parse(JSON.stringify(res.data))
               let stationsList = []
               this.filteredStationsList.forEach(x => {
                 stationsList.push({
                   StationSynonym: x.StationSynonym,
                   StationName: x.StationName,
                   StationId: x.StationId,
                   Alias: x.Alias,
                 })
               })
               aliasList = aliasList.filter(x => {
                 let arrlist = stationsList.map(y => y.StationSynonym)
                 return !arrlist.includes(x.StationSynonym)
               })
               aliasList.forEach(x => {
                 stationsList.push({
                   StationSynonym: x.StationName,
                   StationName: x.StationName,
                   StationId: x.StationId,
                   Alias: [],
                 })
               })
               let hash = {}
               stationsList = stationsList.reduce((item, next) => {
                 hash[next.StationName] ? '' : hash[next.StationName] = true && item.push(next)
                 return item
               }, [])
               aliasList.forEach(x => {
                 stationsList.forEach(y => {
                   if (x.StationName == y.StationName) {
                     y.Alias.push(x.StationSynonym)
                     y.Alias = Array.from(new Set(y.Alias))
                   }
                 })
               })
               this.filteredStationsList = stationsList
             })
             .catch(error => {
               console.error(error)
             })
         }
       },
     },     
     mounted() {
       window.addEventListener('scroll', this.scrollToTop)
     },
   }
 </script>

 <style lang="stylus">
   @require '../node_modules/vuetify/dist/vuetify.min.css';
   @require '../node_modules/mdi/css/materialdesignicons.min.css';
   @require './assets/custom.css';
   @require './assets/animations.css';
   @require './assets/iefixes.css';
   @require './assets/rpd.css';
 </style>

 <style scoped>
   .title {
     color: white;
     text-decoration: none;
   }

   .toolbar__title {
     cursor: pointer;
   }

   .logo {
     margin: 5px;
     background-color: transparent;
   }

   .v-list.tile-spacing>div {
     margin-top: 2px;
     margin-bottom: 2px;
     border-radius: 44px;
   }

   .top {
     position: fixed;
     bottom: 5px;
     right: 10px;
     z-index: 9999;
     opacity: 0.7;
   }
 </style>